import { 
    Title, 
    Text, 
    DetailText 
} from "../../components/units/Text"
import { useState } from "react";
import { OrganizationProps } from "../../interfaces/Organization";
import { useEffect } from "react";
import { 
    FetchMyOrganization, 
    FetchStaffOrganization 
} from "../../components/Rest/Organization";

import { RestApiState } from "../../components/Rest/Organization";
import { BoxWrapper, ConditionalWrapper, ContentWrapper } from "../../components/Wrappers/Wrappers";
import { useSignedInContext } from "../../context/AuthContextProvider";
import { Divider } from "../../components/units/Divider";
import { 
    Building, 
    FetchOwnBuildingList, 
    FetchOrganizationBuildingList
} from "../../components/Rest/Building";
import { UserModel } from "../../context/AuthContextProvider";
import { Client, hasPermission, Service, Support } from "../../roles/roles"
import { useParams } from "react-router-dom";
import { EditOrganization as EditOrganizationDetails } from "../../components/Organization/EditOrganization";
import { EditBuildings } from "../../components/Organization/Buildings";
import { EditDevices } from "../../components/Organization/EditDevices";


enum SectionEnum {
    OrganizationDetails,
    Buildings,
    Devices
}


export interface EditOrganizationDetailsProps {
    details: OrganizationEditViewProps['editOrganizationDetails'];
    setter : (value : any) => void;
}



export interface EditBuildingsProps {
    details: OrganizationEditViewProps['editBuildings'];
    setter : (action: string, key:string, value : any) => void;
    path: string;
    user: UserModel;
    common: OrganizationEditViewProps['common'];
}


interface OrganizationEditViewProps {
    common: {
        CurrentSection: SectionEnum;
        organization_id?: string; 
    };
    editOrganizationDetails: {
        organization: OrganizationProps | null;
        timeOutId: NodeJS.Timeout | null;
        requestState: RestApiState;
        imgStatus: string;
    };
    editBuildings: {
        buildingList: Array<Building>;
        timeOutId: NodeJS.Timeout | null;
        buildingCopy: null | Building;
        requestState: RestApiState;
        imgStatus: string;
        previewImg: string | null;
        delete: {
            requestState: RestApiState;
            timeOutId: NodeJS.Timeout | null;
            code: null | number
        };
        update: {
            requestState: RestApiState;
            timeOutId: NodeJS.Timeout | null;
            code: null | number
        };
        create: {
            requestState: RestApiState;
            timeOutId: NodeJS.Timeout | null;
            code: null | number;
        };
    };
}


const DefaultOrganizationEditViewProps = (orgID: string | undefined, section: string | undefined, user: UserModel) => {
    
    const matchSection = (section:string | undefined, user: UserModel) => {
        switch (section) {
            case "organization":
                if (user.role === Service) {
                    return SectionEnum.Buildings
                }
                return SectionEnum.OrganizationDetails;
            case "buildings":
                return SectionEnum.Buildings;
            case "devices":
                return SectionEnum.Devices;
            default:
                return SectionEnum.OrganizationDetails;
        };
    };

    return {
        common: {
            CurrentSection: matchSection(section, user),
            organization_id: orgID
        },
        editOrganizationDetails: {
            organization: null,
            timeOutId: null, //timeout for an update for handling btn disable state
            requestState: RestApiState.Idle, // update rest api status
            imgStatus: "" // Is used to promt status for image
        },
        editBuildings: {
            buildingList: [],
            buildingCopy: null,
            timeOutId: null, //timeout for an update for handling btn disable state
            requestState: RestApiState.Idle, // update rest api status
            imgStatus: "", // Is used to promt status for image
            previewImg: null,
            delete : {
                timeOutId: null, //timeout for an update for handling btn disable state
                requestState: RestApiState.Idle, // update rest api status
                code: null
            },
            update: {
                timeOutId: null, //timeout for an update for handling btn disable state
                requestState: RestApiState.Idle, // update rest api status
                code: null
            }, 
            create: {
                timeOutId: null, //timeout for an update for handling btn disable state
                requestState: RestApiState.Idle, // update rest api status
                code: null
            }, 

        }
    }
}

export enum useSetStateEnum {
    editBuildings,

}


const OrganizationEditView = () => {
    const { user } = useSignedInContext()
    const { id, setting_option } = useParams()
    const [viewProps, setViewProps] = useState<OrganizationEditViewProps>(DefaultOrganizationEditViewProps(id, setting_option, user))

    const useSetProps = (action: string, key: string, value: any): void => {
        switch (action) {
            case "editBuildings": return void setViewProps(
                prev => ({ ...prev, editBuildings: { ...prev.editBuildings, [key]: value } } ));

            case "addBuilding" : return void setViewProps(prev => ({ ...prev, 
                    editBuildings: { ...prev.editBuildings, 
                        buildingList: [...prev.editBuildings.buildingList, value] 
                    }})
            );

            case "editBuilding":
                return void setViewProps(prev => ({
                    
                    ...prev,
                    editBuildings: {
                        ...prev.editBuildings,
                        buildingList: prev.editBuildings.buildingList.map(building => building.id === value.id ? { ...building, ...value }: building)
                    }
                }));

            case "deleteBuilding":
                return void setViewProps(prev => ({ 
                    ...prev, 
                    editBuildings: { 
                        ...prev.editBuildings, 
                        buildingList: prev.editBuildings.buildingList.filter(building => building.id !== value) 
                    } 
                }));

            case "buildingCreateState" : return void setViewProps(
                prev => ({ ...prev, editBuildings: { ...prev.editBuildings, create : {...prev.editBuildings.create, [key]: value} } } ));

            case "buildingDeleteState" : return void setViewProps(
                prev => ({ ...prev, editBuildings: { ...prev.editBuildings, delete : {...prev.editBuildings.delete, [key]: value} } } ));

            case "updateBuildingState" : return void setViewProps(
                prev => ({ ...prev, editBuildings: { ...prev.editBuildings, update: { ...prev.editBuildings.update, [key]: value }}}));

            case "editBuildingCopy": return void setViewProps(
                (prev:any) => ({ ...prev, editBuildings: { 
                    ...prev.editBuildings,
                    buildingCopy: {
                        ...prev.editBuildings.buildingCopy,
                        [key]: value
                    }
                }
            }));

            case "editBuildingsElement": return void setViewProps(prevState => ({
                ...prevState,
                editBuildings: {
                    ...prevState.editBuildings,
                    buildingList: prevState.editBuildings.buildingList.map((building) => 
                        building.id === value.id ? { ...building, ...{[key]: value} } : building
                    )
                }
            }));
            
            default: throw new Error("Must be one of cases");
        }   
    }

    const organization = viewProps?.editOrganizationDetails?.organization

    const setEditOrganizationDetails = (key: string, value: any):void => {
        setViewProps(prev => (
            {...prev, editOrganizationDetails: {...prev.editOrganizationDetails, [key]: value}}
        ))
    }

    const commonSetter = (key: string, value: any):void => {
        setViewProps(prev => (
            {...prev, common: {...prev.common, [key]: value}}
        ))
    }

    const fetchOrganization = async () => {
        if (user.role === Client) {
            FetchMyOrganization(setEditOrganizationDetails)
        } else {
            if (!viewProps.common.organization_id) {
                throw new Error("ID must be provided")
            }
            FetchStaffOrganization(viewProps.common.organization_id, setEditOrganizationDetails)
        }

    }
    
    const fetchBuildings = async () => {
        if (user.role === Client) {
            FetchOwnBuildingList(
                {role: user.role_slug, action: "editBuildings", key: "buildingList", setter: useSetProps})
        } else {
            FetchOrganizationBuildingList(
                {role: user.role_slug, action: "editBuildings", key: "buildingList", setter: useSetProps, organization_id: id})
        }
    }

    useEffect(() => {
        fetchOrganization()
    }, [])

    useEffect(() => {
        if (viewProps.common.CurrentSection === SectionEnum.OrganizationDetails) {
            fetchOrganization()
        } else if (viewProps.common.CurrentSection === SectionEnum.Buildings) {
            fetchBuildings()
        }
        
    }, [viewProps.common.CurrentSection])

    return (
        <ContentWrapper>        
            <DetailText href={ user.role === Client ? '/react/organization/' : `/react/organization/${id}/details`}>
                Назад
            </DetailText>
            <Title className="dispaly-block">{organization?.organization_name}</Title>
            <br />
            <BoxWrapper className="selectors" p="p0">
                {[Support, Client].includes(user.role) && (
                    <Text 
                        size="xl" 
                        color={ viewProps.common.CurrentSection === SectionEnum.OrganizationDetails ? 'primary' : 'secondary' } 
                        className={`bold fit pointer show-up ${viewProps.common.CurrentSection === SectionEnum.OrganizationDetails ? 'selected' : ''}`}
                        onClick={(e)=>commonSetter('CurrentSection', SectionEnum.OrganizationDetails)}
                    >Организация</Text>
                )}
                <Text 
                    size="xl" 
                    color={ viewProps.common.CurrentSection === SectionEnum.Buildings ? 'primary' : 'secondary' } 
                    className={`bold fit pointer show-up ${viewProps.common.CurrentSection === SectionEnum.Buildings ? 'selected' : ''}`}
                    onClick={(e)=>commonSetter('CurrentSection', SectionEnum.Buildings)}
                >Объекты</Text>
                <Text 
                    size="xl" 
                    color={ viewProps.common.CurrentSection === SectionEnum.Devices ? 'primary' : 'secondary' } 
                    className={`bold fit pointer show-up ${viewProps.common.CurrentSection === SectionEnum.Devices ? 'selected' : ''}`}
                    onClick={(e)=>commonSetter('CurrentSection', SectionEnum.Devices)}
                >Виды техники</Text>
            </BoxWrapper>
            <Divider/>
            <ConditionalWrapper condition={
                viewProps.common.CurrentSection===SectionEnum.OrganizationDetails
                    && hasPermission({role: user.role, resource: 'Organization', action: "update"})}>
                <EditOrganizationDetails 
                    details={viewProps.editOrganizationDetails} 
                    setter={setViewProps} />
            </ConditionalWrapper>
            <ConditionalWrapper condition={
                viewProps.common.CurrentSection===SectionEnum.Buildings
                    && hasPermission({role: user.role, resource: 'Building', action: "list"})}>
                <EditBuildings
                    details={viewProps.editBuildings}
                    setter={useSetProps}
                    path={'editBuildings'}
                    user={user}
                    common={viewProps.common}
                />
            </ConditionalWrapper>
            <ConditionalWrapper condition={
                viewProps.common.CurrentSection===SectionEnum.Devices
                    && hasPermission({role: user.role, resource: 'Device', action: "list"})}>
                <EditDevices />
            </ConditionalWrapper>
        </ContentWrapper>
    )
}

export default OrganizationEditView